module.exports = "uniform vec3 uColor;\nuniform float uAlpha;\n\nvoid main()\n{\n    gl_FragColor = vec4(uColor, uAlpha);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/libs/experience/shaders/token-outline/fragment.glsl
// module id = 412
// module chunks = 0